import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const SUPPORT_ACCESS_FIELD = 'settings.addSupportUserEnabled';

export type SupportAccessSectionProps = SiteSettingsForSiteAdminProps<'addSupportUserEnabled'>;

export function SupportAccessSection(props: SupportAccessSectionProps) {
  return FeatureFlags.addSupportUserEnabled
    ? (
      <SettingsSection title={Messages.addSupportUserSettingSection()}
                       testId={'support-access-setting-section'}
                       description={Messages.addSupportUserSettingDetail()}>
        <FormikCheckbox name={SUPPORT_ACCESS_FIELD}
                        label={Messages.addSupportUserSettingEnable()}
                        testId={'allow-support-access'}>

        </FormikCheckbox>
      </SettingsSection>
    ) : null;
}


export const SupportAccessSectionSpecs = componentRegistryEntry({
  name: 'SupportAccessSection',
  component: SupportAccessSection
});
